module.exports = __webpack_public_path__ + "img/vn.a0081482.svg";